/* import __COLOCATED_TEMPLATE__ from './slider-area.hbs'; */
import Component from '@ember/component';
import { computed, action } from '@ember/object';
import { service } from '@ember/service';

import { eng3 } from '@ebiz/pretty-num';

var setStep = function (left, right) {
  var step = '0.';
  left = left.toString();
  right = right.toString();
  let v1 = left.indexOf('.') !== -1 ? left.substring(left.indexOf('.') + 1).length : 0;
  let v2 = right.indexOf('.') !== -1 ? right.substring(right.indexOf('.') + 1).length : 0;
  var max = Math.max(v1, v2);
  for (var i = 0; i <= max; i++) {
    step += i != 0 ? '0' : '';
    if (max == i) {
      step += '1';
      break;
    }
  }
  return Number(step);
};

/////////////////////////////////////////////////////////////////////////////////////////
// silder-area - Component containing the common mode and differential voltage sliders //
/////////////////////////////////////////////////////////////////////////////////////////

export default class SliderArea extends Component {
  tagName = '';
  @service intl;

  /////////////////////////////////////////////////////////////////////////////////////
  // Computed Values                                                                 //
  /////////////////////////////////////////////////////////////////////////////////////

  @computed('projectData.varTypeSlider') get vTSliderOut() {
    return eng3(this.projectData.varTypeSlider) === ' ' ? 0 : eng3(this.projectData.varTypeSlider);
  }

  @computed('projectData.vDiffSlider') get vDSliderOut() {
    return eng3(this.projectData.vDiffSlider) === ' ' ? 0 : eng3(this.projectData.vDiffSlider);
  }

  @computed('projectData.{varTypeLeft,varTypeRight}') get minVarType() {
    return Math.min(this.projectData.varTypeLeft, this.projectData.varTypeRight);
  }

  @computed('projectData.{varTypeLeft,varTypeRight}') get maxVarType() {
    return Math.max(this.projectData.varTypeLeft, this.projectData.varTypeRight);
  }

  @computed('projectData.{vDiffLeft,vDiffRight}') get minVDiff() {
    return Math.min(this.projectData.vDiffLeft, this.projectData.vDiffRight);
  }

  @computed('projectData.{vDiffLeft,vDiffRight}') get maxVDiff() {
    return Math.max(this.projectData.vDiffLeft, this.projectData.vDiffRight);
  }

  @computed('projectData.{varTypeLeft,varTypeRight}') get varTypeSteps() {
    return setStep(this.projectData.varTypeLeft, this.projectData.varTypeRight);
  }

  @computed('projectData.{vDiffLeft,vDiffRight}') get vDiffSteps() {
    return setStep(this.projectData.vDiffLeft, this.projectData.vDiffRight);
  }

  @computed('projectData.{varTypeLeft,varTypeRight}') get varSliderDisabled() {
    return this.projectData.varTypeLeft === this.projectData.varTypeRight;
  }

  @computed('projectData.{vDiffLeft,vDiffRight}') get vdiffSliderDisabled() {
    return this.projectData.vDiffLeft === this.projectData.vDiffRight;
  }

  /////////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                               //
  /////////////////////////////////////////////////////////////////////////////////////

  @action updateVarTypeSlider(evt) {
    var newSliderValue = Number(evt.target.value);
    if (this.projectData.varTypeSlider !== newSliderValue) {
      this.updateSlider('varTypeSlider', newSliderValue);
    }
  }

  @action updateVDiffSlider(evt) {
    var newSliderValue = Number(evt.target.value);
    if (this.projectData.vDiffSlider !== newSliderValue) {
      this.updateSlider('vDiffSlider', newSliderValue);
    }
  }
}
